module.exports = __webpack_public_path__ + "img/beauty.e2a17328.png";